import { Box, withStyles } from "@material-ui/core";
import { LineColor } from "meta/utils/colors";
const Line = withStyles({
    root: {
        height: 28,
        borderBottom: "2px solid " + LineColor,
    },
})(Box);
const BottomLine = ({ children, ...props }) => (<Line {...props}>{children}</Line>);
export default BottomLine;
